module.exports = __webpack_public_path__ + "static/media/CopyLinkIcon2.708ad62f.svg";